import React, { useEffect, useState } from 'react';
import { ThemeContext } from './themeContextTypes';
import type { Theme } from './themeContextTypes';

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useState<Theme>(() => {
    const savedTheme = localStorage.getItem('news-theme') as Theme | null;
    return savedTheme || 'classic';
  });

  useEffect(() => {
    document.documentElement.classList.remove(
      'theme-classic',
      'theme-dark',
      'theme-coder'
    );
    document.documentElement.classList.add(`theme-${theme}`);
    localStorage.setItem('news-theme', theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

